import * as React from "react";

export default function TimePicker({onChange, style}) {
    return React.createElement('input', {
        type: 'time',
        onInput: onChange,
        style: style || {},
    })
}